/* eslint-disable no-restricted-globals */
/* eslint-disable no-alert */
import React, { useState, useRef } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Row, Col, Card, CardBody, CardHeader, Modal, Label,
} from 'reactstrap';
import { withTranslation } from 'react-i18next';
import QRCode from 'qrcode';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import {
  Formik, Field, Form, ErrorMessage,
} from 'formik';
import * as Yup from 'yup';

import { post } from '../../helpers/api_helper';
import { Can } from '../../utilities/Can';
import BaseGrid from '../../components/Common/BaseGrid';

function ClientApi(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const { t } = props;
  const [signal, setSignal] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalClient, setModalClient] = useState(null);
  const [connectModalOpen, setConnectModalOpen] = useState(false);

  const qrCodeRef = useRef(null);

  const deleteApp = async (row) => {
    if (window.confirm(props.t('Are you sure you want to delete this app?'))) {
      await post(`/api/rest/app/${row.id}/delete`, {});
      setSignal(signal + 1);
    }
  };

  const createApp = async (values) => {
    try {
      const client = await post('/api/rest/app/create', values);
      setSignal(signal + 1);

      setModalClient(client);
    } catch (e) {
      toastr.error(e.message);
    }
  };

  const showQrCode = async (row) => {
    setModalClient(row);
    setConnectModalOpen(true);
  };

  const connectModalOpened = () => {
    const canvas = qrCodeRef.current;

    QRCode.toCanvas(canvas, JSON.stringify({
      id: modalClient.id, client_secret: modalClient.client_secret, host: `https://${window.location.host}/api/v1/`,
    }), {
      width: 300,
      height: 300,
    }, (error) => {
      if (error) {
        toastr.error(error.message);
      }
    });
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col md="7">
            <Card>
              <CardHeader className="bg-transparent border-bottom">{props.t('Client Apps')}</CardHeader>
              <CardBody>
                <Can i="see" this="client_api">
                  <BaseGrid
                    url="/api/rest/app"
                    shouldUpdate={signal}
                    create={() => setModalOpen(true)}
                    config={
                    {
                      columns: {
                        name: {
                          label: t('Name'),
                          sort: true,
                        },
                        id: {
                          label: t('Client ID'),
                        },
                        actions: {
                          label: 'Actions',
                          actions: [
                            {
                              key: 'qr_code',
                              icon: 'mdi mdi-qrcode',
                              class: 'btn btn-sm btn-soft-dark',
                              alt: t('Connect App'),
                              click: showQrCode,
                            },
                            {
                              key: 'remove_app',
                              icon: 'mdi mdi-close-thick',
                              class: 'btn btn-sm btn-soft-danger text-dark',
                              alt: t('Delete App'),
                              click: deleteApp,
                            },
                          ],
                        },
                      },
                      pagination: {
                        sort: 'id',
                        direction: 'desc',
                        perPage: 30,
                      },
                    }
                    }
                  />

                  <Modal
                    size="md"
                    isOpen={modalOpen}
                    backdrop="static"
                  >
                    <div className="modal-header">
                      <h5
                        className="modal-title mt-0"
                        id="myLargeModalLabel"
                      >
                        {t('Create App')}
                      </h5>
                      <button
                        onClick={() => {
                          if (modalClient === null) {
                            setModalOpen(false);
                          }

                          if (modalClient !== null && confirm(t('"I\'ve copied the details already"'))) {
                            setModalClient(null);
                            setModalOpen(false);
                          }
                        }}
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      {modalClient !== null && (
                        <>
                          <p>{t('Copy this down somewhere. It will no longer be visible after you close this.')}</p>
                          <div className="fs-4 mt-3 mb-3">
                            <strong className="fs-6">{t('Client ID')}</strong>
                            <pre>{modalClient.id}</pre>
                          </div>
                          <div className="fs-4 mt-3 mb-3">
                            <strong className="fs-6">{t('Client Secret')}</strong>
                            <pre>{modalClient.client_secret}</pre>
                          </div>
                        </>
                      )}
                      {modalClient === null && (
                        <Formik
                          enableReinitialize
                          initialValues={{ name: '' }}
                          validationSchema={Yup.object().shape({
                            name: Yup.string().required(t('Name is required')),
                          })}
                          onSubmit={(values) => {
                            createApp(values);
                          }}
                        >
                          {({
                            // eslint-disable-next-line no-unused-vars
                            touched, errors, setFieldValue,
                          }) => (
                            <Form id="AppForm" autoComplete="off">
                              <Row>
                                <Col sm="6">
                                  <div className="mb-3">
                                    <Label
                                      for="name"
                                      className="col-form-label"
                                    >
                                      {props.t('App Name')}
                                    </Label>
                                    <Field
                                      type="text"
                                      className={`form-control ${(errors.name && touched.name ? 'is-invalid' : '')}`}
                                      id="name"
                                      name="name"
                                      onChange={(e) => {
                                        setFieldValue('name', e.target.value);
                                      }}
                                    />
                                    <ErrorMessage
                                      name="name"
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </div>
                                </Col>
                              </Row>
                            </Form>
                          )}
                        </Formik>
                      )}
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        onClick={() => {
                          if (modalClient === null) {
                            setModalOpen(false);
                          }

                          if (modalClient !== null && confirm(t('"I\'ve copied the details already"'))) {
                            setModalClient(null);
                            setModalOpen(false);
                          }
                        }}
                        className="btn btn-soft-dark"
                        data-dismiss="modal"
                      >
                        {modalClient === null ? t('Cancel') : t('Close')}
                      </button>
                      {modalClient === null && (
                        <button
                          type="submit"
                          form="AppForm"
                          className="btn btn-primary"
                        >
                          {t('Create App')}
                        </button>
                      )}
                    </div>
                  </Modal>
                </Can>

                <Can not i="see" this="client_api"><p>{props.t('Unauthorized')}</p></Can>
              </CardBody>
            </Card>
          </Col>

          <Col lg="3">
            <Card>
              <CardBody>
                <span className="fs-6">
                  Check out the
                  {' '}
                  <a href="https://shopjimmy.github.io/partner-api/">{t('documentation')}</a>
                </span>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Modal isOpen={connectModalOpen} onOpened={connectModalOpened} size="md">
          <div className="modal-header">
            <h5
              className="modal-title mt-0"
            >
              {t('Connect App')}
            </h5>
            <button
              onClick={() => setConnectModalOpen(false)}
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body text-center">
            <canvas ref={qrCodeRef} />
            <p>{t('Scan this with Android app to connect the device')}</p>
          </div>
        </Modal>
      </div>
    </div>
  );
}

ClientApi.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(ClientApi));
